import { useStore } from '../../context';

export const useJsonFile = () => {
  const text = useStore(({ file: f }) => f.getTextContent());

  return { json: JSON.parse(text) };
};
